import type { FC } from "react";

import { languageSelector, useViewportInfoContext } from "@/src/contexts";
import type { IStepper, IStepperItem, IStepperLine } from "@Components/Stepper/Stepper";
import Stepper from "@Components/Stepper/Stepper";

import IcoGotBonusCircle from "@Images/Mgm/IcoGotBonusCircle.svg";
import IcoRegisterCircle from "@Images/Mgm/IcoRegisterCircle.svg";
import IcoSendCodeCircle from "@Images/Mgm/IcoSendCodeCircle.svg";
import IcoShoppingCircle from "@Images/Mgm/IcoShoppingCircle.svg";

import { MgmSharedResources } from "./MgmShared.Resources";
import { MgmSharedResourcesEn } from "./MgmShared.Resources.En";

import * as portalCss from "../../shared/Portal.module.css";
import * as css from "./MgmHowItWorks.module.css";

const MgmHowItWorks: FC = () => {
    const { mgmHowItWorks } = languageSelector(MgmSharedResources, MgmSharedResourcesEn);
    const { isMobileOrTablet } = useViewportInfoContext();

    const stepList: IStepperItem[] = [
        {
            description: mgmHowItWorks.item1Text,
            svgFile: IcoSendCodeCircle,
        },
        {
            description: mgmHowItWorks.item2Text,
            svgFile: IcoRegisterCircle,
        },
        {
            title: "",
            description: mgmHowItWorks.item3Text,
            svgFile: IcoShoppingCircle,
        },
        {
            description: mgmHowItWorks.item4Text,
            svgFile: IcoGotBonusCircle,
        },
    ];

    const getLineInfo = () => {
        if (isMobileOrTablet) {
            return {
                height: "85%",
                width: "0",
            } as IStepperLine;
        }

        return {
            height: "0",
            width: "100%",
        } as IStepperLine;
    };

    const steps: IStepper = {
        stepList,
        lineInfo: getLineInfo(),
        lineColor: "#c2c2c2",
    };

    return (
        <div className={`${css.mgmHowItWorksComponent} ${portalCss.standardContainerV2}`}>
            <h2
                className={`${css.title} ${portalCss.setSectionColOne}`}
                dangerouslySetInnerHTML={{ __html: mgmHowItWorks.title }}
            />

            <div className={`${css.listWrapper} ${portalCss.setSectionColOne}`}>
                <Stepper {...steps} />
            </div>
        </div>
    );
};

export default MgmHowItWorks;
